var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBreakIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M0 0h14v14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 497,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-320",
    transform: "translate(-234 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(15 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Break-Icon-",
    transform: "translate(219 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10a1 1 0 11-2 0 1 1 0 112 0",
    id: "Fill-1",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8a1 1 0 01-1-1V4a1 1 0 112 0v3a1 1 0 01-1 1",
    id: "Fill-3",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.515 13h4.97L13 9.485v-4.97L9.486 1H4.515L1 4.515v4.97L4.515 13zm5.178 1H4.308a.504.504 0 01-.354-.146L.147 10.046A.5.5 0 010 9.692V4.308a.5.5 0 01.147-.354L3.954.146A.504.504 0 014.308 0h5.385c.133 0 .259.053.353.146l3.808 3.808a.5.5 0 01.146.354v5.384a.5.5 0 01-.146.354l-3.808 3.808a.501.501 0 01-.353.146z",
    id: "Fill-5",
    fill: "#FFF"
  }))))))));
}

SvgBreakIcon.displayName = 'BreakIcon';
export default SvgBreakIcon;